import rocket from "./icons/rocket.png";
import tools from "./icons/tools.png";

export const email = "kaljakubowska@gmail.pl";

export const personalInfo = [
  {
    title: "My skillset includes",
    icon: tools,
    list: [
      "JavaScript ES6+",
      "React",
      "Redux-Saga",
      "Redux (Toolkit)",
      "React Hooks",
      "React Router",
      "Semantic & accessible HTML",
      "Responsive Web Design",
      "CSS BEM convention",
      "CSS Grid",
      "CSS Flexbox",
      "Working with API (axios)",
      "Teamwork",
      "Markdown",
      "Immutability",
      "Error handling",
      "Promises, Async/Await",
      "GitHub Pull Requests & Review",
      "Trello",
      "Scrum",
      "NPM",
      "Git",
    ],
  },
  {
    title: "What I want to learn next",
    icon: rocket,
    list: [
      "Typescript",
      "Node.js",
      "Unit testing",
      "React Context",
      "Cypress",
    ],
  },
];

export const githubUserName = "KalinaJakubowska";

export const apiLink = `https://api.github.com/users/${githubUserName}/repos`;
